import { shallow } from 'zustand/shallow'
import React, { useState } from 'react'

import { Autocomplete, Button, Group, List, Stack, Text } from '@mantine/core'
import { GloThemeManager } from './ThemeManager'

export const CSSError = (props: any) => {
  return (
    <Group spacing={'xs'} position='center' grow>
      <Text>Failed to loaded the required CSS</Text>
      <List>
        {React.Children.map(
          GloThemeManager.items?.filter((i) => i.loadstatus != 'loaded'),
          (item) => (
            <List.Item>
              {item.path}
              <br />
              {item.loadstatus}: {item.error}
            </List.Item>
          )
        )}
      </List>
    </Group>
  )
}
